import dayjs from "dayjs";
import actions from "./actions";

const initState = {
  invoices: [],
  invoiceForm: {
    date_range: [dayjs().add(-1, "d"), dayjs()],
    invoice_status: "All",
  },
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.SET_INVOICE_FORM: {
      return {
        ...state,
        invoiceForm: action.payload,
      };
    }
    case actions.SET_ALL_INVOICES: {
      return {
        ...state,
        invoices: action.payload,
      };
    }
    default:
      return state;
  }
}
